import { combineReducers, Reducer } from "@reduxjs/toolkit";
import addressReducer from "./addressReducer";
import cartReducer from "./cartReducer";
import contentReducer from "./contentReducer";
import packageReducer from "./packageReducer";
import personDetailsReducer from "./personalDetailsReducer";
import { FORM_ID } from "../../../../constants";
import { createReducer as createFormsReducer } from "../../rapidform";

const reducer: Reducer = combineReducers({
    address: addressReducer,
    packages: packageReducer,
    cart: cartReducer,
    content: contentReducer,
    personalDetails: personDetailsReducer,
    [FORM_ID.PERSONAL_DETAILS_FWA]: createFormsReducer(FORM_ID.PERSONAL_DETAILS_FWA),
});

export default reducer;
